import {createStrokeSVG} from './TEMPLATE'

// tabler: arrow-down
export const ArrowBottom_Stroke2_Corner0_Rounded = createStrokeSVG({
  paths: ['M12 5l0 14', 'M18 13l-6 6', 'M6 13l6 6'],
  viewBox: '0 0 24 24',
  strokeWidth: 2,
})

// tabler: arrow-left
export const ArrowLeft_Stroke2_Corner0_Rounded = createStrokeSVG({
  paths: ['M5 12l14 0', 'M5 12l6 6', 'M5 12l6 -6'],
  viewBox: '0 0 24 24',
  strokeWidth: 2,
})

// tabler: arrow-right
export const ArrowRight_Stroke2_Corner0_Rounded = createStrokeSVG({
  paths: ['M5 12l14 0', 'M13 18l6 -6', 'M13 6l6 6'],
  viewBox: '0 0 24 24',
  strokeWidth: 2,
})

// tabler: arrow-up-right
export const ArrowTopRight_Stroke2_Corner0_Rounded = createStrokeSVG({
  paths: ['M17 7l-10 10', 'M8 7l9 0l0 9'],
  viewBox: '0 0 24 24',
  strokeWidth: 2,
})

// tabler: arrow-up
export const ArrowTop_Stroke2_Corner0_Rounded = createStrokeSVG({
  paths: ['M12 5l0 14', 'M18 11l-6 -6', 'M6 11l6 -6'],
  viewBox: '0 0 24 24',
  strokeWidth: 2,
})
